import { t } from "i18next";

import React from "react";
import { FaTrashAlt } from "react-icons/fa";
import { Card, Col, Collapse } from "reactstrap";

import { setUsedGifts } from "@components/OrderTaking/Store/feature";

import { handleCodePromoSymbole } from "@pages/Kiosk/Loyalty/loyaltyHelper";

import "./promoCode.css";
import usePromoCodeHook from "./promoCodeHook";

export function PromoCode(): JSX.Element {
    const {
        dispatch,
        usedGifts,
        totalReduce,
        btnColor,
        isExpanded,
        setIsExpanded,
        textColor,
    } = usePromoCodeHook();
    return (
        <Card className="code-promo-card-container">
            <Col
                className="w-100 d-flex justify-content-between align-items-center code-promo-card-col"
                style={{
                    borderRadius: isExpanded
                        ? "19px 19px 0 0"
                        : "19px 19px 19px 19px",
                }}
            >
                <div
                    className="m-3 d-flex justify-content-between align-items-center"
                    style={{ gap: "10px", color: textColor }}
                >
                    <span className="code-promo-card-title">
                        {t("Promotions")}
                    </span>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center code-promo-offer-container">
                    <span
                        style={{
                            color: textColor,
                        }}
                    >
                        {totalReduce}
                    </span>
                    <button
                        onClick={() => setIsExpanded(!isExpanded)}
                        className=" d-flex justify-content-center align-items-center see-details"
                        style={{
                            backgroundColor: textColor,
                            color: btnColor,
                            width: "150px",
                        }}
                    >
                        {isExpanded ? t("Hide details") : t("See details")}
                    </button>
                </div>
            </Col>
            <Collapse isOpen={isExpanded}>
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                        boxShadow: "0px 3px 6px #00000080",
                        borderBottomLeftRadius: " 19px",
                        borderBottomRightRadius: "19px",
                    }}
                >
                    <div
                        className="m-3 d-flex justify-content-between align-items-center"
                        style={{ gap: "10px" }}
                    >
                        <span
                            style={{
                                font: "normal normal bold 32px/54px Nunito",
                            }}
                        >
                            {`${t("Discount Coupon of ")}${
                                usedGifts[0].discountValue
                            }${handleCodePromoSymbole(
                                Number(usedGifts[0].discountType)
                            )}`}
                        </span>
                    </div>
                    <div className="d-flex flex-row justify-content-between align-items-center code-promo-offer-text">
                        <span>{totalReduce}</span>
                        <FaTrashAlt
                            className="code-promo-trash-icon"
                            onClick={() => dispatch(setUsedGifts([]))}
                        />
                    </div>
                </div>
            </Collapse>
        </Card>
    );
}
